module.exports = __webpack_public_path__ + "static/media/divine_helmet.5e478060.png";